import { CardComponentProps } from "@~/types/types";
import { TickCircleFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickCircleFilled";
import styles from "./AddToBasketFeedbackMessage.module.scss";
import { useCachedBasketData } from "@~/product-card-components/__shared__/AddToBasketUtils/hooks/useCachedBasket.ts";
import config from "@~/envConfig";
import { useVariant } from "@~/contexts/VariantContext/VariantContext.tsx";

export function AddToBasketFeedbackMessage({
  product,
}: Pick<CardComponentProps, "product">) {
  const { variant } = useVariant();
  const basketHostURL = config.hostUrl;
  const cachedBasketData = useCachedBasketData();
  const productInBasket = cachedBasketData?.find((item) => {
    return item.skuId === (variant?.aliases.skuId ?? product.initialSkuId);
  });

  if (!productInBasket?.quantity) {
    return null;
  }
  return (
    <div data-component="AddToBasketFeedbackMessage">
      <small className={styles.title}>
        <TickCircleFilled />
        <span>
          &nbsp;{productInBasket?.quantity}x added to&nbsp;
          <a href={`${basketHostURL}/basket`}>your basket</a>
        </span>
      </small>
    </div>
  );
}
